import axios from "axios";
import Swal from "sweetalert2";
export const getData = async () => {
  const url = process.env.REACT_APP_API_BASEURL;
  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const id = urlParams.get("id");
  const tokenUser = urlParams.get("token");

  const getTokenUser = async () => {
    const response = await axios.get(
      `${url}/signature/request/token-temporary?token=${tokenUser}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const newToken = response.data.authorisation.token;
    sessionStorage.setItem("token_user", newToken);
    return newToken;
  };

  try {
    const token = await getTokenUser();

    if (!token) {
      throw new Error(
        `[${new Date().toISOString()}] Token inválido ou não obtido com sucesso.`
      );
    }
    const response = await axios.get(`${url}/request-signature/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error.response.data?.message ||
      error.response.data?.errors?.error ||
      "Tente novamente";
    Swal.fire({
      title: "Erro!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#355B94",
    });
    // Propaga o erro para quem chamou a função, se necessário
    throw error;
  }
};
